import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import type { PdfWidgetSnapshot } from "../pdfTypes";
import type { PdfRect } from "../pdfLayout";
import { CHART_HEADER_HEIGHT } from "./chartPdfRenderer";

const s = StyleSheet.create({
  cell: {
    position: "absolute",
    borderWidth: 1,
    borderColor: "#e8e8e8",
    borderRadius: 4,
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  title: { fontSize: 10, fontWeight: 600, textAlign: "left", color: "#1a1a1a" },
  headerRow: { flexDirection: "row", alignItems: "center" },
  summary: { fontSize: 7, textAlign: "right", color: "rgba(0,0,0,0.55)" },
  placeholder: { justifyContent: "center", alignItems: "center", backgroundColor: "#f8f9fa" },
  placeholderText: { fontSize: 9, color: "#999" },
});

export function renderBodyMap(
  snapshot: Extract<PdfWidgetSnapshot, { type: "body_map" }>,
  rect: PdfRect,
  scale: number,
  image?: string,
) {
  const padH = 6;
  const padV = 6;
  const hasHeader = !!(snapshot.title || snapshot.summary);
  const headerH = hasHeader ? CHART_HEADER_HEIGHT : 2;
  const imgWidth = rect.width - 2 * padH;
  const imgHeight = rect.height - headerH - padV;

  return (
    <View style={[s.cell, { left: rect.left, top: rect.top, width: rect.width, height: rect.height }]}>
      {hasHeader && (
        <View style={[s.headerRow, { paddingTop: padV, paddingHorizontal: padH }]}>
          <Text style={[s.title, { flex: 1 }]}>{snapshot.title}</Text>
          {snapshot.summary && <Text style={s.summary}>{snapshot.summary}</Text>}
        </View>
      )}
      {image ? (
        <Image
          src={image}
          style={{
            position: "absolute",
            left: padH,
            top: headerH,
            width: imgWidth,
            height: imgHeight,
            objectFit: "contain",
          }}
        />
      ) : (
        <View style={[s.placeholder, {
          position: "absolute",
          left: padH,
          top: headerH,
          width: imgWidth,
          height: imgHeight,
        }]}>
          <Text style={s.placeholderText}>Body Map</Text>
        </View>
      )}
    </View>
  );
}
